import React from 'react';
import CommentDisplay from './CommentDisplay';
import { formatDistanceToNow, isToday } from 'date-fns';
import { AllCommentsForRiskAssessmentQuery } from '@/__generated__/graphql';
import { CommentsLoader } from '@/components/shared/Comments/CommentsLoader';
import { Stack } from '@mui/material';
import { CommentsFallbackMessage } from './CommentsFallbackMessage';
import { useNavbarHeight } from '../../../../hooks/useNavbarHeight';

type Props = {
  comments: AllCommentsForRiskAssessmentQuery['allComments'];
  loading: boolean;
};

const CommentsList = ({ comments, loading = false }: Props) => {
  const navbarHeight = useNavbarHeight();
  if (!loading && comments?.length === 0) return <CommentsFallbackMessage type="empty" />;
  if (loading) return <CommentsLoader />;
  return (
    <Stack
      sx={{
        height: `calc(100vh - ${navbarHeight + 52}px)`,
        overflowX: 'auto',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      <Stack gap={'2rem'} my={'3.6rem'}>
        {comments?.map((comment) => {
          const date = new Date(Number(comment.updatedAt));

          const relativeTime = isToday(date)
            ? 'Today'
            : formatDistanceToNow(date, { addSuffix: true });

          return (
            <CommentDisplay
              key={comment.id}
              createdAt={relativeTime}
              title={comment.title}
              text={comment.text}
              id={comment.id}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};

export default React.memo(CommentsList);
